import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ProposalSectionBlock } from "@/components/shared/ProposalSectionBlock";

export default function PublicProposalPage() {
  const { token } = useParams();
  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
  const [proposal, setProposal] = useState(null);
  const [error, setError] = useState("");
  const [decidedName, setDecidedName] = useState("");
  const [decided, setDecided] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/proposals/${token}`).then(({ data }) => setProposal(data.proposal)).catch((err) => setError(err.response?.data?.detail || "This link is invalid or has expired."));
  }, [API, token]);

  const decide = async (action) => {
    setBusy(true);
    try {
      await axios.post(`${API}/public/proposals/${token}/${action}`, { decided_by_name: decidedName || null });
      setDecided(action);
    } catch (err) { setError(err.response?.data?.detail || "Something went wrong."); } finally { setBusy(false); }
  };

  if (error) return <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6"><p className="rounded-xl bg-red-50 px-5 py-4 text-sm font-semibold text-red-600" data-testid="public-proposal-error">{error}</p></div>;
  if (!proposal) return <div className="flex min-h-screen items-center justify-center bg-slate-50"><p className="text-sm text-slate-400">Loading…</p></div>;

  return (
    <div className="min-h-screen bg-slate-50 py-10" data-testid="public-proposal-page">
      <div className="mx-auto max-w-2xl space-y-4 px-4">
        {proposal.sections.map((s, i) => <ProposalSectionBlock key={i} section={s} />)}

        <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="public-proposal-decision-card">
          {decided || !proposal.can_decide ? (
            <p className="text-center text-sm font-bold text-slate-600" data-testid="public-proposal-decision-result">
              {decided === "accept" || proposal.status === "Accepted" ? "Thank you — you've accepted this Proposal." : decided === "decline" || proposal.status === "Declined" ? "You've declined this Proposal." : `This Proposal is ${proposal.status}.`}
            </p>
          ) : (
            <>
              <label className="mb-2 block text-xs font-bold uppercase tracking-wide text-slate-400">Your name (optional)</label>
              <input value={decidedName} onChange={(e) => setDecidedName(e.target.value)} data-testid="public-proposal-name-input" className="mb-3 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm" />
              <div className="flex gap-3">
                <button type="button" disabled={busy} onClick={() => decide("accept")} data-testid="public-proposal-accept-btn" className="flex-1 rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white hover:bg-emerald-700 disabled:opacity-50">Accept Proposal</button>
                <button type="button" disabled={busy} onClick={() => decide("decline")} data-testid="public-proposal-decline-btn" className="flex-1 rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-50 disabled:opacity-50">Decline</button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
